import { TurboPickupChevronRightIcon } from 'src/components/Icons/TurboPickupChevronRightIcon'

import type { TurboPickupTag } from './getActiveTurboPickupTags'
import { TurboPickupFlag } from './TurboPickupFlag'
import type { TurboPickupStore } from './types'

type TurboPickupStoreCardProps = {
  store: TurboPickupStore
  tag?: TurboPickupTag
  onSelect: (store: TurboPickupStore) => void
}

export function TurboPickupStoreCard({
  store,
  tag,
  onSelect,
}: TurboPickupStoreCardProps) {
  const { pickupName, distance, address } = store
  const { street, number, city, state } = address

  const distanceLabel =
    distance < 1
      ? `${Math.round(distance * 1000)}m`
      : `${distance.toFixed(1)}km`

  return (
    <li className="pb-4">
      <button
        className="w-full flex items-center gap-3 pt-4 text-left hover:bg-[#f9fafb] transition-colors"
        aria-label={`Selecionar loja ${pickupName}`}
        data-testid="turbo-pickup-store-card"
        onClick={() => onSelect(store)}
      >
        <div className="flex-1 flex flex-col gap-1 min-w-0">
          <div className="flex items-center gap-2 flex-wrap">
            <span className="text-[15px] font-semibold text-turboPickupTitle leading-snug">
              {pickupName.replace('Loja - ', '')}
            </span>
            <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-turboPickupBadgeBg text-[11px] font-semibold text-turboPickupBadgeText whitespace-nowrap">
              {distanceLabel}
            </span>
          </div>
          <span className="text-[13px] text-turboPickupBody leading-snug truncate">
            {street}, {number} - {city} - {state}
          </span>
        </div>

        <TurboPickupChevronRightIcon className="shrink-0" aria-hidden="true" />
      </button>
      {tag && <TurboPickupFlag text={tag.text} linkUrl={tag.linkUrl} />}
    </li>
  )
}
